import { useEffect, useState } from 'react';

export function useInactivityTimer(timeout = 300000) { // Default is 5 minutes
  const [lastActivity, setLastActivity] = useState(Date.now());

  useEffect(() => {
    // This function resets the timer
    const resetTimer = () => {
      setLastActivity(Date.now());
    };

    // List of events that indicate user activity
    const activityEvents = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'];
    
    // Add event listeners for all activity events
    activityEvents.forEach(event => {
      window.addEventListener(event, resetTimer);
    });

    // --- The Timeout Logic ---
    const inactivityCheck = setTimeout(() => {
      // If the current time is greater than the last activity time + timeout duration
      console.log('User has been inactive. Refreshing page...');
      window.location.reload();
    }, timeout);

    // --- Cleanup Function ---
    // This runs when the component unmounts or when lastActivity changes
    return () => {
      // Remove all the event listeners
      activityEvents.forEach(event => {
        window.removeEventListener(event, resetTimer);
      });
      // Clear the timeout
      clearTimeout(inactivityCheck);
    };
  }, [lastActivity, timeout]); // Re-run this effect when lastActivity changes
}